module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__pagination-paginator"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('ul', [(_vm.prev) ? _c('li', {
    staticClass: "prev"
  }, [_c(_vm.prevDisabled ? "div" : "ext-link", {
    tag: "ext-link",
    staticClass: "link",
    attrs: {
      "size": "normal"
    },
    on: {
      "click": function($event) {
        !_vm.prevDisabled ? _vm.$emit("input", _vm.current - 1) : ""
      }
    }
  }, [_vm._t("prev", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prevText)
    }
  })])], 2)], 1) : _vm._e(), _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "page"
    }, [_c('div', {
      staticClass: "link",
      class: _vm.disabled(item.number) ? "link-active" : ""
    }, [_vm._v(_vm._s(item.text))])])
  }), (_vm.next) ? _c('li', {
    staticClass: "next"
  }, [_c(_vm.nextDisabled ? "div" : "ext-link", {
    tag: "ext-link",
    staticClass: "link",
    attrs: {
      "size": "normal"
    },
    on: {
      "click": function($event) {
        !_vm.nextDisabled ? _vm.$emit("input", _vm.current + 1) : ""
      }
    }
  }, [_vm._t("next", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nextText)
    }
  })])], 2)], 1) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db3f525","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/examination-item/components/pagination/Paginator.vue
// module id = 66efcf9699e11cceb9ae
// module chunks = 3